import React from "react";
import { useNavigate } from "react-router-dom";

const DecideButton = ({ href, label, icon, disabled, ...res }) => {
    const navigate = useNavigate();

    return(
        <button
            className={`
                w-full h-[35vh] flex flex-col items-center justify-center p-4 text-center ${disabled ? "bg-gray-500" : "bg-rs-azul"} rounded-lg hover:bg-rs-rojo shadow-md
                transition transform hover:scale-105 shadow-black hover:shadow-xl hover:shadow-rs-rojo`}
            onClick={()=> navigate(href)}
            disabled={disabled}
            {...res}
        >
            {React.createElement(icon, { size: 50, color: "white" })}
            <h2 className="text-white text-xl font-bold">{label}</h2>
        </button>
    );
};

export default DecideButton;